import { ACTION_TYPES, useFilasEsperaDispatch, useFilasEsperaState } from "./filas-espera-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { IFilaEsperaPagedRequest } from "models/request/fila-espera-paged-request";
import { downloadFile } from "utils/download-file";

export const useFilasEsperaController = () => {
    const dispatch = useFilasEsperaDispatch();
    const { filaPagedRequest } = useFilasEsperaState();

    async function exportFilas(format: string) {
        const file = await MunicipalPortalAAppService.exportFilasEspera(filaPagedRequest, format);
        downloadFile(file);
    }

    async function onInit() {
        let request = { page: 0, pageSize: 10 } as IFilaEsperaPagedRequest;

        // Permite chegar já filtrado (ex.: card "Creches" no Acesso Rápido -> /filas-espera?tipo=1),
        // sem precisar que o cidadão saiba que precisa selecionar o tipo manualmente.
        const tipoParam = new URLSearchParams(window.location.search).get("tipo");
        if (tipoParam) {
            request.idTipoFilaEspera = Number(tipoParam);
        }

        dispatch({ type: ACTION_TYPES.setFilaPagedRequest, payload: request });
        dispatch({ type: ACTION_TYPES.setLoading, payload: true });

        await listFilas(request);

        try {
            const [ultimaAtualizacao, tipos] = await Promise.all([
                MunicipalPortalAAppService.getFilasEsperaUltimaAtualizacao(),
                MunicipalPortalAAppService.listTiposFilaEspera()
            ]);
            dispatch({ type: ACTION_TYPES.setUltimaAtualizacao, payload: ultimaAtualizacao?.dtaUltimaAtualizacao ?? null });
            dispatch({ type: ACTION_TYPES.setTipos, payload: tipos });
        } catch (error) {
            console.log(error);
        }

        dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    async function listFilas(request: IFilaEsperaPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            dispatch({ type: ACTION_TYPES.setError, payload: null });

            const filas = await MunicipalPortalAAppService.listFilasEspera(request);

            dispatch({ type: ACTION_TYPES.setFilas, payload: filas });
        } catch (error) {
            console.log(error);
            dispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar as filas de espera. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChange = (e: any) => {
        let updated = { ...filaPagedRequest };

        if (e.target.name === "text-field-term") {
            updated.term = e.target.value;
            if (!updated.term) {
                (async () => await listFilas({ ...updated, page: 0 }, true))();
            }
        } else if (e.target.name === "select-tipo-id") {
            updated.idTipoFilaEspera = e.target.value;
        } else if (e.target.name === "select-order-direction") {
            updated.orderDirection = e.target.value;
            (async () => await listFilas({ ...updated, page: 0 }, true))();
        }

        dispatch({ type: ACTION_TYPES.setFilaPagedRequest, payload: updated });
    };

    return { listFilas, handleOnChange, onInit, exportFilas };
}
